import isObject from './isObject';

/**
 * Deep merge two objects.
 * https://gist.github.com/Salakar/1d7137de9cb8b704e48a
 * @param target
 * @param source
*/
export default function deepMerge(target, source) {
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    });
  }
  return target;
}



// WEBPACK FOOTER //
// ./app/utils/object/deepMerge.js